import { render, staticRenderFns } from "./HeaderOrder.vue?vue&type=template&id=a28f1dba&scoped=true"
import script from "./HeaderOrder.vue?vue&type=script&lang=js"
export * from "./HeaderOrder.vue?vue&type=script&lang=js"
import style0 from "./HeaderOrder.vue?vue&type=style&index=0&id=a28f1dba&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a28f1dba",
  null
  
)

export default component.exports